import React, { createContext, useCallback, useContext, useState } from 'react'

export const HeaderDataContext = createContext(null)

export const useHeaderDataContext = () => useContext(HeaderDataContext)

const KEY = 'top-line-id'

const HeaderDataContextProvider = ({ children }) => {
  const hasViewed = localStorage?.getItem(KEY)
  const [visibleTopLine, setVisibleTopLine] = useState(false)

  const setTopLineVisibility = useCallback((val) => {
    if (hasViewed) {
      return false
    }

    setVisibleTopLine(val)
  })

  const closeTopLine = useCallback((id) => {
    localStorage.setItem(KEY, id)
    setVisibleTopLine(false)
  })

  return (
    <HeaderDataContext.Provider
      value={{ visibleTopLine, setTopLineVisibility, closeTopLine }}
    >
      {children}
    </HeaderDataContext.Provider>
  )
}
export default HeaderDataContextProvider
